<template>
  <v-dialog
    v-model="accountDialog"
    width="550"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header info"
        primary-title
      >
        <b v-if="data.id !== undefined">{{ $t('accounts.editAcc') }}</b>
        <b v-else>{{ $t('accounts.addAcc') }}</b>
      </v-card-title>

      <v-card-text class="mt-5">
        <edit-exchange-account
          v-if="accountDialog" 
          ref="accEdit"
          :fields="data"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="$emit('closeEditAccountDialog', false)"
        >
          {{ $t('globals.cancelButton') }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="save()"
        >
          {{ $t('globals.saveButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EditExchangeAccount from '@/views/Partials/EditExchangeAccount.vue'

export default {
  name: 'EditAccountDialog',
  components: {
    EditExchangeAccount
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
     showDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accountDialog: {
      get() {
        return this.showDialog
      },
      set(val) {}
    }
  },
  methods: {
    async save() {
      this.loading = true
      if (await this.$refs.accEdit.save()) {
        this.$emit('closeEditAccountDialog', true)
      }  
      this.loading = false    
    }
  }
}
</script>

<style>

</style>
